import React from 'react';
import { Badge } from 'react-bootstrap';
import { InterpretationStatus, TestDataStatus, Priority } from '../../types';

interface StatusBadgeProps {
  status: InterpretationStatus | TestDataStatus | Priority;
  type?: 'interpretation' | 'testdata' | 'priority';
}

const statusConfig: Record<string, { bg: string; label: string }> = {
  // Interpretation statuses
  processing: { bg: 'info', label: 'Procesando' },
  pending_review: { bg: 'warning', label: 'Pendiente de Revisión' },
  approved: { bg: 'success', label: 'Aprobado' },
  approved_with_edit: { bg: 'primary', label: 'Editado y Aprobado' },
  rejected: { bg: 'danger', label: 'Rechazada' },
  // Written by the Step Function, not by a lambda: `error` on a caught failure,
  // `timeout` when auditor review exceeds the task-token window.
  timeout: { bg: 'secondary', label: 'Expirada' },
  // TestData statuses
  pending: { bg: 'warning', label: 'Pendiente' },
  interpreted: { bg: 'success', label: 'Interpretado' },
  error: { bg: 'danger', label: 'Error' },
  // Accepted and stored, but never interpreted: the source system could not resolve
  // the patient in the EHR. No screen passes a TestData status to this badge today --
  // the three call sites all pass `interpretation.status` -- so this entry is here for
  // the first one that does, instead of letting it fall through to the raw string.
  unresolved_patient: { bg: 'secondary', label: 'Paciente sin resolver' },
  // Priority
  high: { bg: 'danger', label: 'Alta' },
  medium: { bg: 'warning', label: 'Media' },
  low: { bg: 'secondary', label: 'Baja' },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status] || { bg: 'secondary', label: status };

  return (
    <Badge bg={config.bg} className="status-badge">
      {config.label}
    </Badge>
  );
};

export default StatusBadge;
